import { useOutletContext } from 'react-router-dom'
import { CentroCusto } from 'service/api'

export function useCentroCustoOutletContext() {
    return useOutletContext<{
        data?: CentroCusto[]
    }>()
}
